const CJK_REGEX = /[一-鿿㐀-䶿]/;

export function maskParticipantName(firstName, lastName) {
  const fn = (firstName || '').trim();
  const ln = (lastName || '').trim();

  if (!fn && !ln) return '';

  if (CJK_REGEX.test(fn) || CJK_REGEX.test(ln)) {
    let surname;
    let given;
    if (ln.length === 1) {
      surname = ln;
      given = fn;
    } else if (fn.length === 1) {
      surname = fn;
      given = ln;
    } else {
      surname = ln || fn;
      given = ln && fn && ln !== fn ? fn : '';
    }

    if (!surname) return fn || ln;
    if (given.length >= 2) return surname + 'X' + given[given.length - 1];
    return surname + 'X';
  }

  const base = fn || ln;
  return base.length > 1 ? base.slice(0, -1) + 'X' : base + 'X';
}
